import styled from 'styled-components';
import { gridSizes, media } from 'utils/style';

export const Container = styled.div`
  display: flex;
  padding: 0px;
  height: calc(100vh - 72px);
`;

export const PageError = styled.div`
  margin: auto;
  padding: 0 10px;
  font-weight: 500;
  font-size: 3rem;
`;

export const ColumnInfo = styled.div`
  width: 50%;
  overflow-y: scroll;

  ${media.lessThan('medium')`
    width: 60%;
    `}

  ${media.lessThan('small')`
      width: 100%;
    `}
`;

export const InfoContainer = styled.div`
  width: 496px;
  margin: 0 auto;

  ${media.lessThan('small')`
      width: 98%;
      max-width: 496px;
    `}

  > div:not(:last-child), ul {
    padding: ${gridSizes('M')};

    ${media.lessThan('extraSmall')`
      padding: ${gridSizes('M')};
      margin: 4px;
      background: #fff;
      width: initial !important;
      border-radius: 2px;
    `};
  }
`;

export const ColumnMap = styled.div`
  width: 50%;

  ${media.lessThan('medium')`
    width: 40%;
    `}

  ${media.lessThan('small')`
      display: none;
    `}
`;
